<script>
export default {
  data() {
    return {
      
    }
  }
}
</script>

<template>
  <div :class="$style.decoration">
    <ul class="decoartion__list">
      <li v-for="i in 5" :key="i" :data-length="i"></li>
    </ul>
  </div>
</template>

<style lang="scss" module>
.decoration {
  :global {
    .decoartion {
      &__list {
        display: flex;
        @include list-unstyled;
        li {
          width: 1rem;
          height: 1rem;
          border-radius: 100%;
          background: $color-primary;
          &:not(:last-child) {
            margin-right: 3.9rem;
          }
          @for $i from 1 through 5 {
            &[data-length="#{$i}"] {
              opacity: calc(1 - (#{$i} * 0.2) + 0.2 );
            }
          }
        }
      }
    }
  }
}
</style>